import React, { useState, useEffect } from "react";
import PDFViewer from "pdf-viewer-reactjs";
import { Row, Col, Button, Skeleton } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  UndoOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import { reqPostDownloadBase64 } from "../../axios/api";

const contentType = "application/pdf";
const zoomForDesktop = "100";

const b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, {
    type: contentType,
    headers: {
      filename: "test.pdf",
    },
  });
  return blob;
};

const generateDownloadLink = (theBlob, fileName, contentType) => {
  var blob = new Blob([theBlob], { type: contentType });
  var blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");

  link.href = blobUrl;
  link.download = fileName;

  document.body.appendChild(link);

  link.dispatchEvent(
    new MouseEvent("click", {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  );
};
export const PdfViewer = (props) => {
  const { blobcontainer, filename, useUrl } = props;

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [fileLoading, setFileLoading] = useState(false);
  const [disableDownload, setDisableDownload] = useState(false);

  useEffect(() => {
    if (useUrl != null) {
      setFileLoading(true);
      setPdfBlobUrl(useUrl);
      setFileLoading(false);
      setDisableDownload(true);
      let url = useUrl.split("/");
      var formData = new FormData();
      formData.append("blobcontainer", url[url.length - 2]);
      formData.append("filename", url[url.length - 1]);
      reqPostDownloadBase64(formData)
        .then((res) => {
          if (res.data.isSuccess) {
            let blob = b64toBlob(res.data.fileObj, contentType);
            setPdfBlob(blob);
            setDisableDownload(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [useUrl]);
  useEffect(() => {
    if (blobcontainer != null && filename != null) {
      setFileLoading(true);
      var formData = new FormData();
      formData.append("blobcontainer", blobcontainer);
      formData.append("filename", filename);
      reqPostDownloadBase64(formData)
        .then((res) => {
          if (res.data.isSuccess) {
            let blob = b64toBlob(res.data.fileObj, contentType);
            let blobUrl = URL.createObjectURL(blob);
            setPdfBlob(blob);
            if (useUrl == null) {
              setPdfBlobUrl(blobUrl);
            }
            setFileLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [blobcontainer, filename]);
  const CustomNavigation = (data) => {
    const { page, pages } = data;
    const { handlePrevClick, handleNextClick } = data;
    const {
      handleZoomIn,
      handleResetZoom,
      handleZoomOut,
      maxScale,
      minScale,
      scale,
    } = data;

    return (
      <div className="custom-pdf-viewer-navigation">
        <Row>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Previous"
              onClick={handlePrevClick}
              disabled={page === 1}
            >
              <LeftOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <span
              style={{
                display: "inline-block",
                marginTop: "5px",
                color: "white",
              }}
            >
              Page {page} from {pages}
            </span>
          </Col>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Next"
              onClick={handleNextClick}
              disabled={page === pages}
            >
              <RightOutlined />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Zoom In"
              onClick={handleZoomIn}
              disabled={maxScale == scale}
            >
              <ZoomInOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <Button
              title="Zoom Reset"
              className="custom-pdf-nav-btn"
              onClick={handleResetZoom}
            >
              <UndoOutlined />
            </Button>
          </Col>
          <Col xs={8}>
            <Button
              className="custom-pdf-nav-btn"
              title="Zoom Out"
              onClick={handleZoomOut}
              disabled={minScale == scale}
            >
              <ZoomOutOutlined />
            </Button>
          </Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Button
              className="custom-pdf-nav-btn"
              title="Download"
              disabled={disableDownload}
              onClick={handleDownload}
            >
              <DownloadOutlined />
            </Button>
          </Col>
        </Row>
      </div>
    );
  };
  const CustomPDFViewer = () => {
    return (
      <>
        <PDFViewer
          document={{
            url: pdfBlobUrl,
          }}
          navigation={CustomNavigation}
          navbarOnTop={true}
        />
      </>
    );
  };
  const handleDownload = () => {
    let urlFilename = null;
    if (useUrl != null) {
      let url = useUrl.split("/");
      urlFilename = url[url.length - 1];
    }
    generateDownloadLink(pdfBlob, urlFilename ?? filename, contentType);
  };

  return (
    <Skeleton loading={fileLoading} active>
      {pdfBlobUrl != null ? (
        <>
          {isMobile ? (
            <CustomPDFViewer />
          ) : (
            <object
              data={pdfBlobUrl + "#zoom=" + zoomForDesktop}
              type={contentType}
              width="100%"
              height="800px"
            >
              <CustomPDFViewer />
              {/* <embed
                src={pdfBlobUrl + "#zoom=" + zoomForDesktop}
                type={contentType}
                width="100%"
                height="800px"
              ></embed> */}
            </object>
          )}
        </>
      ) : (
        <></>
      )}
    </Skeleton>
  );
};
